
import { defineComponent } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { config } from "@/core/helpers/config";
import store from "@/store";
// import store from "@/store";

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    let mailid = store.getters.emailid;
    let accountid = store.getters.AccountId;
    let accountname = store.getters.AccountName;
    /**
     * Submit form
     * @param event
     */
    return {
      config,
      mailid,
      accountid,
      accountname,
    };
  },
  methods: {
    toggle(event) {
      // added event as second arg
      event.preventDefault();
      // save new config to localStorage
      localStorage.setItem("config", JSON.stringify(config.value));
    },
  },
});
